
import { Component, Vue, Watch } from 'vue-property-decorator';
import ImagesUpload from '@/components/ImagesUpload/images-upload.vue';
import TextNotice from '@/views/android/components/TextNotice.vue';
import Recharge from '@/components/Recharge/index.vue';
import Advert from '@/components/Advert/index.vue';
import FloatAdvert from '@/components/Advert/float.vue';
import { PublicQuery } from '@/mixins/public_query';
import { adAddEdit, getAdList } from '@/api/exchange-code';
import { iImagesList, iAdparams, eInputType, iTextList, eOpenState, iMyPageList } from '@/interface/exchange-code';
import { eOptionType } from '@/interface/eCommand';
import { toast } from '@/utils/common';
import { eEndPoint } from '@/interface/hot-game';
// import float from '@/components/Advert/float.vue';
import SingleImageUpload from '@/components/SingleImageUpload/index.vue';
@Component({
  components: { ImagesUpload, TextNotice, Recharge, Advert, FloatAdvert, SingleImageUpload },
})
export default class AdsenseNotice extends Vue {
  publicQuery = new PublicQuery();
  defaultuploadSizeType = '1080*740 png,jpg';
  indexBannerUploadSizeType = '1080*740 png,jpg';
  maxW: Number = 1080;
  maxH: Number = 740;
  indexBannerMaxH: number = 740;
  androidType: eEndPoint = eEndPoint.ADNROID;
  route = 'route';
  evaluateModel: any = {
    imageUrl: '',
  };
  // evaluateDescModel: any = {
  //   width: 1240,
  //   height: 1240,
  //   maxLen: 32,
  //   format: 'jpg,png',
  //   isFixed: false,
  // };
  rechargeModel: any = {
    state: true,
    desc: '',
    popupState: true,
    imageUrl: '',
    width: 0,
    height: 0,
    grade_type: -1,
    grade_id: -1,
  };
  rechargeDesc: any = {
    width: 797,
    height: 1215,
    maxLen: 32,
  };
  advertModel: any = {
    linkState: this.route,
    imageUrl: '',
    appid: '-1',
    website: '',
    width: 0,
    height: 0,
    bannerId: '',
    bannerSize: '',
    bannerLoop: false,
    grade_type: -1,
    grade_id: -1,
  };
  advertDesc: any = {
    width: 1013,
    height: 230,
    maxLen: 32,
    format: 'jpg,png',
    isFixed: true,
  };
  floatAdvertModel: any = {
    linkState: this.route,
    imageUrl: '',
    appid: '-1',
    website: '',
    width: 0,
    height: 0,
    grade_type: -1,
    grade_id: -1,
    state: true,
  };
  floatAdvertDesc: any = {
    width: 240,
    height: 240,
    maxLen: 32,
    format: 'jpg,png',
    isFixed: true,
  };
  openTypeList: any = [
    {
      label: '跳转链接',
      value: 'link',
    },
    {
      label: '打开游戏',
      value: 'game',
    },
  ];
  gameList: any = [];
  extend: any = {
    game_id: -1,
  };
  isDelete?: boolean = true;
  route_type: number = 0;
  publicModel: iImagesList = {
    id: '',
    position: '1',
    positionValue: '0', // 位置值
    imageUrl: '',
    uploadText: '添加图片',
    isClass: true,
    uploadSizeType: this.defaultuploadSizeType,
    extend: this.extend,
    fillText: [
      {
        title: '类型',
        value: 'game',
        placeholder: '',
        type: eInputType.RADIO,
        childrens: this.openTypeList,
      },
      { title: '', value: '', placeholder: '请输入跳转连接', type: eInputType.INPUT, isRelevance: true }, //isRelevance s是否有关联
      {
        title: '',
        value: -1,
        placeholder: '请输入关键字搜索',
        type: eInputType.SELECT,
        isRelevance: true,
        childrens: this.gameList,
        filterable: true,
      },
      { title: '按钮名称', value: '启动游戏', placeholder: '请输入启动按钮名称,不能超过5个', type: eInputType.INPUT, isRelevance: false, max: 5 },
    ],
  };
  idx_img: string = 'idx_img';
  idx_img_index: string = 'idx_img_index';
  idx_word: string = 'idx_word';
  idx_charge: string = 'idx_charge';
  idx_mypage: string = 'idx_mypage';
  idx_float: string = 'idx_float';
  idx_evaluate: string = 'idx_evaluate';
  all_idx = 'idx_img,idx_img_index,idx_word,idx_charge,idx_mypage,idx_float,idx_evaluate';
  app_id = 'android_client';
  bannerList: iImagesList[] = [];
  imagesList: iImagesList[] = [];
  textImage: iImagesList[] = [];
  myPageList: iMyPageList[] = [];
  publicTextModel: iImagesList = {
    id: '',
    position: '1',
    positionValue: '0', // 位置值
    imageUrl: '',
    isClass: true,
    extend: this.extend,
    fillText: [
      {
        title: '公告文字',
        value: '',
        placeholder: '请输入标题，不超过384个字',
        type: eInputType.INPUT,
        isRelevance: false,
        max: 384,
      },
      {
        title: '类型',
        value: 'game',
        placeholder: '',
        type: eInputType.RADIO,
        childrens: this.openTypeList,
      },
      { title: '', value: '', placeholder: '请输入跳转连接', type: eInputType.INPUT, isRelevance: true }, //isRelevance s是否有关联
      {
        title: '',
        value: -1,
        placeholder: '请输入关键字搜索',
        type: eInputType.SELECT,
        isRelevance: true,
        childrens: this.gameList,
        filterable: true,
      },
    ],
  };
  paramsImages: iAdparams = {
    app_id: this.app_id,
    advs: [
      {
        idx: '',
        idx_name: '',
        pos: '',
        pos_name: '',
        img: '',
        main_title: '',
        sub_title: '',
        link: '',
        extend: '',
        op_type: '',
      },
    ],
  };
  loading: boolean = false;
  endpoint: number = 0;
  /* 验证 */
  rules() {
    let flag = true;
    this.paramsImages.advs = [];
    let selectValue: number = -1;
    let count = 0;
    for (let item of this.imagesList) {
      selectValue = parseInt(item.fillText![2].value);
      if (!item.imageUrl) {
        this.$message.error('图片位--' + item.position + '位置图片未上传');
        flag = false;
        return flag;
      } else if (item.fillText![0].value == eOptionType.GAME) {
        if (selectValue <= 0) {
          this.$message.error('图片位--' + item.position + '游戏类型未选择');
          flag = false;
          return flag;
        }
      }
      this.paramsImages.advs.push({
        idx: this.idx_img,
        idx_name: '图片位',
        pos: JSON.stringify(count),
        pos_name: JSON.stringify(count + 1),
        img: item.imageUrl,
        main_title: '',
        link: item.fillText![1].value,
        op_type: item.fillText![0].value /* 类型 */,
        extend:
          item.fillText![0].value == 'game'
            ? JSON.stringify({
                game_id: selectValue,
                banner_bottom: item.fillText![3].value,
              })
            : '',
      });
      count++;
    }

    let bannerCount = 0;
    for (let item of this.bannerList) {
      selectValue = parseInt(item.fillText![2].value);
      if (!item.imageUrl) {
        this.$message.error('首页-Banner图片位--' + item.position + '位置图片未上传');
        flag = false;
        return flag;
      } else if (item.fillText![0].value == eOptionType.GAME) {
        if (selectValue <= 0) {
          this.$message.error('首页-Banner图片位--' + item.position + '游戏类型未选择');
          flag = false;
          return flag;
        }
      }
      this.paramsImages.advs.push({
        idx: this.idx_img_index,
        idx_name: '首页-banner图位',
        pos: String(bannerCount),
        pos_name: String(bannerCount + 1),
        img: item.imageUrl,
        main_title: '',
        link: item.fillText![1].value,
        op_type: item.fillText![0].value /* 类型 */,
        extend:
          item.fillText![0].value == 'game'
            ? JSON.stringify({
                game_id: selectValue,
                banner_bottom: item.fillText![3].value,
              })
            : '',
      });
      bannerCount++;
    }

    if (this.route_type == this.androidType) {
      for (let i = 0; i < this.textImage.length; i++) {
        const textItem = this.textImage[i];
        const value = textItem.fillText![0].value;
        const typeValue = textItem.fillText![1].value; //类型
        const linkValue = textItem.fillText![2].value; //连接
        const gameId = textItem.fillText![3].value; //游戏ID

        let pos = (i + 1).toString();
        if (value.trim() == '') {
          this.$message.error('文字位' + pos + '--内容未填写');
          flag = false;
          return flag;
        }
        if (value.length > 384) {
          this.$message.error('文字位' + pos + '--内容不能超过48个字');
          flag = false;
          return flag;
        }

        this.paramsImages.advs.push({
          idx: this.idx_word,
          idx_name: '公告',
          pos: pos,
          pos_name: pos,
          main_title: value,
          img: '',
          link: linkValue,
          op_type: typeValue /* 类型 */,
          extend:
            typeValue == 'game'
              ? JSON.stringify({
                  game_id: gameId,
                })
              : '',
        });
        count++;
      }

      //我的页面
      for (let index = 0; index < this.myPageList.length; index++) {
        const { linkState, appid, grade_id, bannerId, bannerSize, website, imageUrl: adImageUrl, width: width, height: height, grade_type } = this.myPageList[
          index
        ];
        let num = index + 1;
        if (!adImageUrl && linkState != 'csj') {
          this.$message.error('请选择我的页面' + num + '的图片!');
          flag = false;
          return flag;
        }
        if (linkState == this.route) {
          if (appid == '-1') {
            this.$message.error('请选择我的页面' + num + ',APP内部跳转页面!');
            flag = false;
            return flag;
          } else {
            if ((appid === 'coin' || appid === 'card') && grade_id <= 0) {
              this.$message.error('请选择我的页面' + num + ',对应的充值档位!');
              flag = false;
              return flag;
            }
          }
        } else if (linkState == 'csj') {
          if (!bannerId.trim()) {
            this.$message.error('请输入我的页面' + num + ',穿山甲代码位!');
            flag = false;
            return flag;
          } else if (!bannerSize.trim()) {
            this.$message.error('请选择我的页面' + num + ',穿山甲广告位尺寸!');
            flag = false;
            return flag;
          }
        } else {
          if (!website.trim()) {
            this.$message.error('请输入我的页面' + num + ',跳转链接!');
            flag = false;
            return flag;
          }
        }
        this.paramsImages.advs.push({
          idx: 'idx_mypage',
          idx_name: '我的页面' + num,
          pos: '我的页面' + num,
          pos_name: '我的页面' + num,
          img: adImageUrl,
          main_title: '',
          sub_title: '',
          grade_type: grade_type,
          grade_id: grade_id,
          link: linkState === 'csj' ? bannerId : linkState == this.route ? appid : website,
          op_type: linkState /* 类型 */,
          disable: false,
          extend: this.createBannerAdSize(this.myPageList[index]),
        });
      }
      //充值位
      const { state, popupState, desc, imageUrl, width, height, grade_id, grade_type } = this.rechargeModel;
      if (state) {
        if (popupState) {
          if (!imageUrl) {
            this.$message.error('请选择充值弹出图片!');
            flag = false;
            return flag;
          }
        }
      }
      this.paramsImages.advs.push({
        idx: 'idx_charge',
        idx_name: '充值位',
        pos: '充值位',
        pos_name: '充值位',
        img: imageUrl,
        main_title: desc,
        sub_title: '',
        grade_type: grade_type,
        grade_id: grade_id,
        link: '',
        op_type: '' /* 类型 */,
        extend: JSON.stringify({
          width: width,
          height: height,
        }),
        disable: !state,
        default_show: popupState,
      });
      // 安卓悬浮广告位
      flag = this.floatAdvertRules();
      if (!flag) {
        return;
      }
      //好评有礼
      flag = this.evaluateModelRules();
      if (!flag) {
        return;
      }
    }
    return flag;
  }

  createBannerAdSize(item: iMyPageList) {
    const { linkState, bannerSize, bannerLoop, width: adWidth, height: adHeight } = item;
    if (linkState !== 'csj') {
      return JSON.stringify({
        width: adWidth,
        height: adHeight,
      });
    }
    const size = bannerSize.split('x');

    return JSON.stringify({
      width: Number(size[0]) || 0,
      height: Number(size[1]) || 0,
      slideshow: bannerLoop,
    });
  }

  floatAdvertRules(): boolean {
    let flag: boolean = true;
    const { state, linkState, imageUrl, appid, website, width, height, grade_type, grade_id } = this.floatAdvertModel;
    if (state) {
      if (!imageUrl) {
        this.$message.error('请选择悬浮窗图片!');
        flag = false;
        return flag;
      }
      if (linkState === 'link') {
        if (!website.trim()) {
          this.$message.error('请输入跳转链接!');
          flag = false;
          return flag;
        }
      } else {
        if (appid === '-1') {
          this.$message.error('请选择悬浮窗广告APP内部跳转类型!');
          flag = false;
          return flag;
        }
        if (appid === 'coin' || appid === 'card') {
          if (grade_type === -1 || grade_id === -1) {
            this.$message.error('请选择充当档位!');
            flag = false;
            return flag;
          }
        }
      }
      this.paramsImages.advs.push({
        disable: false,
        idx: 'idx_float',
        idx_name: '悬浮窗',
        pos: '悬浮窗',
        pos_name: '悬浮窗',
        img: imageUrl,
        main_title: '',
        sub_title: '',
        grade_type: grade_type,
        grade_id: grade_id,
        link: linkState === 'link' ? website : appid,
        op_type: linkState /* 类型 */,
        extend: JSON.stringify({
          width: width,
          height: height,
        }),
      });
    } else {
      this.paramsImages.advs.push({
        disable: true,
        idx: 'idx_float',
        idx_name: '悬浮窗',
        pos: '悬浮窗',
        pos_name: '悬浮窗',
        img: '',
        main_title: '',
        sub_title: '',
        grade_type: -1,
        grade_id: -1,
        link: '',
        op_type: linkState /* 类型 */,
        extend: JSON.stringify({
          width: width,
          height: height,
        }),
      });
    }
    return flag;
  }
  evaluateModelRules(): boolean {
    let flag: boolean = true;
    const { imageUrl } = this.evaluateModel;
    if (!imageUrl) {
      this.$message.error('请选择好评有礼的图片!');
      flag = false;
      return flag;
    }
    this.paramsImages.advs.push({
      disable: false,
      idx: 'idx_evaluate',
      idx_name: '好评有礼',
      pos: '好评有礼',
      pos_name: '好评有礼',
      img: imageUrl,
      main_title: '',
      op_type: '' /* 类型 */,
      sub_title: '',
      link: '',
      extend: '',
    });

    return flag;
  }
  floatADGTypeChange(val: number) {
    this.floatAdvertModel.grade_type = val;
    this.floatAdvertModel.grade_id = -1;
  }
  advertADGTypeChange(val: number, index: number) {
    this.myPageList[index].grade_type = val;
    this.myPageList[index].grade_id = -1;
  }
  advertDelete(index: number) {
    this.myPageList.splice(index, 1);
  }

  async submitSave() {
    const flag = await this.rules();

    if (flag && this.paramsImages && this.paramsImages.advs.length > 0) {
      this.$msgbox({
        title: '提示',
        message: '请仔细检查配置内容及跳转链接，确认生效后，将立即生效。',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            this.loading = true;
            console.log('提交的数据: ', this.paramsImages);
            await this.saveAd(this.paramsImages);
            done();
            instance.confirmButtonLoading = false;
            this.loading = false;
          } else if (action === 'cancel') {
            done();
            instance.confirmButtonLoading = false;
            this.loading = false;
          }
        },
      }).then(() => {
        // done();
      });
    }
  }
  /* 新增、修改 */
  async saveAd(params: iAdparams) {
    try {
      const res = await adAddEdit(params);

      if (res && res.code === 0) {
        //
        this.$message.success('保存成功');
      }
    } catch (err) {
      console.log(err);
    }
  }
  /* 赋值 */
  async getList() {
    try {
      const res = await getAdList({ app_id: this.app_id, idx: this.all_idx });
      if (res && res.code == 0) {
        for (let item of res.data) {
          if (item.idx === this.idx_img) {
            const eLen: number = item.advs.length;
            const sLen: number = this.imagesList.length;
            if (sLen < eLen) {
              this.addImageText(sLen, eLen);
            }
            for (let key of item.advs) {
              try {
                const { pos, img, op_type, link, extend } = key;
                this.imagesList[pos].fillText![0].value = op_type;
                this.imagesList[pos].fillText![1].value = link;
                this.imagesList[pos].imageUrl = img;
                /* 得到扩展项目 */
                const extentItem: any = extend == '' ? '' : JSON.parse(extend);
                if (extentItem) {
                  this.imagesList[pos].fillText![2].value = extentItem.game_id; /* 扩展的游戏id */
                  if (this.route_type == eEndPoint.WEB) {
                    this.imagesList[pos].fillText![3].value = extentItem.banner_bottom; //只有route_type=2web端才有banner按钮
                  }
                }
              } catch (err) {
                console.log(err);
              }
            }
          }

          if (item.idx === this.idx_img_index) {
            const eBLen: number = item.advs.length;
            const sBLen: number = this.bannerList.length;
            if (sBLen < eBLen) {
              this.addBannerImageText(sBLen, eBLen);
            }
            for (let key of item.advs) {
              try {
                const { pos, img, op_type, link, extend } = key;
                this.bannerList[pos].fillText![0].value = op_type;
                this.bannerList[pos].fillText![1].value = link;
                this.bannerList[pos].imageUrl = img;
                this.bannerList[pos].uploadSizeType = this.indexBannerUploadSizeType;
                /* 得到扩展项目 */
                const extentItem: any = extend == '' ? '' : JSON.parse(extend);
                if (extentItem) {
                  this.bannerList[pos].fillText![2].value = extentItem.game_id; /* 扩展的游戏id */
                  if (this.route_type == eEndPoint.WEB) {
                    this.bannerList[pos].fillText![3].value = extentItem.banner_bottom; //只有route_type=2web端才有banner按钮
                  }
                }
              } catch (err) {
                console.log(err);
              }
            }
          }

          if (item.idx === this.idx_word) {
            let oldLength = this.textImage.length;
            let newLength = item.advs.length;
            for (let i = oldLength; i < newLength; i++) {
              this.addTextList();
            }
            for (let i = 0; i < newLength; i++) {
              const { pos, op_type, link, extend, main_title } = item.advs[i];

              for (let key of item.advs) {
                this.textImage[i].fillText![0].value = main_title;
                this.textImage[i].fillText![1].value = op_type == '' ? 'game' : op_type;
                this.textImage[i].fillText![2].value = link;
                const extentItem: any = extend == '' ? '' : JSON.parse(extend);
                if (extend != '') {
                  this.textImage[i].fillText![3].value = extentItem.game_id; /* 扩展的游戏id */
                }
              }
            }
          }
          if (item.idx === this.idx_charge) {
            let newLength = item.advs.length;
            if (newLength > 0) {
              const { img, main_title, disable, default_show, extend, grade_id, grade_type } = item.advs[0];
              this.rechargeModel.desc = main_title;
              this.rechargeModel.imageUrl = img;
              this.rechargeModel.grade_id = grade_id;
              this.rechargeModel.grade_type = grade_type;
              this.rechargeModel.state = !disable;
              this.rechargeModel.popupState = default_show;
              this.rechargeModel.width = JSON.parse(extend).width;
              this.rechargeModel.height = JSON.parse(extend).height;
            }
          }
          if (item.idx === this.idx_mypage) {
            let newLength = item.advs.length;
            if (newLength > 0) {
              item.advs.forEach((item: any) => {
                const { img, link, op_type, extend: adextend, grade_type, grade_id } = item;
                let newAdvertModel: iMyPageList = JSON.parse(JSON.stringify(this.advertModel));
                newAdvertModel.imageUrl = img;
                newAdvertModel.linkState = op_type;
                newAdvertModel.appid = op_type !== 'link' ? link : '';
                newAdvertModel.grade_type = grade_type;
                newAdvertModel.grade_id = grade_id;
                newAdvertModel.width = JSON.parse(adextend).width;
                newAdvertModel.height = JSON.parse(adextend).height;
                if (op_type == this.route) {
                  newAdvertModel.appid = link;
                } else if (op_type === 'csj') {
                  newAdvertModel.bannerId = link;
                  newAdvertModel.bannerSize = JSON.parse(adextend).width + 'x' + JSON.parse(adextend).height;
                  newAdvertModel.bannerLoop = JSON.parse(adextend).slideshow;
                } else {
                  newAdvertModel.website = link;
                }
                this.myPageList.push(newAdvertModel);
              });
            }
          }
          if (item.idx === this.idx_float) {
            // console.log('悬浮窗广告位: ', item);
            if (item.advs && item.advs.length) {
              const { disable, img, link, op_type, grade_type, grade_id, extend: adextend } = item.advs[0];
              this.floatAdvertModel.linkState = op_type;
              this.floatAdvertModel.imageUrl = img;
              this.floatAdvertModel.appid = op_type !== 'link' ? link : '';
              this.floatAdvertModel.website = link;
              this.floatAdvertModel.grade_type = grade_type;
              this.floatAdvertModel.grade_id = grade_id;
              this.floatAdvertModel.width = JSON.parse(adextend).width;
              this.floatAdvertModel.height = JSON.parse(adextend).height;
              this.floatAdvertModel.state = !disable;
            } else {
              this.floatAdvertModel.state = false;
            }
          }
          if (item.idx === this.idx_evaluate) {
            // console.log('悬浮窗广告位: ', item);
            if (item.advs && item.advs.length) {
              const { img } = item.advs[0];
              this.evaluateModel.imageUrl = img;
            }
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
  }
  /* 游戏类别 */
  async getGameList() {
    const res: any = await this.publicQuery.getGameList();
    if (res) {
      this.gameList = res;
      this.publicModel.fillText![2].childrens = this.gameList;
      this.publicTextModel.fillText![3].childrens = this.gameList;
    }
  }
  /*动态添加图为 默认图位只有一个，其余的动态生成 */
  addImageText(starIndex: number, endIndex: number) {
    if (starIndex < endIndex) {
      for (let i = starIndex + 1; i <= endIndex; i++) {
        this.imagesList.push(JSON.parse(JSON.stringify(this.publicModel)));
      }
    } else {
      this.imagesList.push(JSON.parse(JSON.stringify(this.publicModel)));
    }
  }
  addBannerImageText(starIndex: number, endIndex: number) {
    if (starIndex < endIndex) {
      for (let i = starIndex + 1; i <= endIndex; i++) {
        this.bannerList.push(JSON.parse(JSON.stringify(this.publicModel)));
      }
    } else {
      this.bannerList.push(JSON.parse(JSON.stringify(this.publicModel)));
    }
  }
  async setValue() {
    await this.getGameList();
    this.publicModel.uploadSizeType = this.defaultuploadSizeType;
    this.addImageText(1, 1);
    //this.textImage = this.publicTextModel; // [{ title: '公告文字', value: '', placeholder: '请输入标题，不超过48个字', max: 48 }];
    this.textImage.push(JSON.parse(JSON.stringify(this.publicTextModel)));
    // console.log(this.textImage);

    this.getList();
  }
  /* 新增banner图位 */
  addimagesList() {
    const num: number = this.imagesList.length;
    if (this.route_type == 2) {
      if (num >= 5) {
        toast('您最多只能添加5个banner', 'error');
        return;
      }
    }
    this.publicModel.position = JSON.stringify(num + 1);
    this.publicModel.positionValue = JSON.stringify(num);
    this.imagesList.push(JSON.parse(JSON.stringify(this.publicModel)));
  }

  /* 新增首页banner图位 */
  addIndexImagesList() {
    const num: number = this.bannerList.length;
    if (this.route_type == 2) {
      if (num >= 5) {
        toast('您最多只能添加5个banner', 'error');
        return;
      }
    }
    this.publicModel.position = JSON.stringify(num + 1);
    this.publicModel.positionValue = JSON.stringify(num);
    this.publicModel.uploadSizeType = this.indexBannerUploadSizeType;
    this.bannerList.push(JSON.parse(JSON.stringify(this.publicModel)));
  }

  //新增文字位
  addTextList() {
    this.textImage.push(JSON.parse(JSON.stringify(this.publicTextModel)));
  }
  //新增我的页面
  addMypage() {
    this.myPageList.push(JSON.parse(JSON.stringify(this.advertModel)));
  }
  //删除文字位
  deleteText(index: number) {
    this.textImage.splice(index, 1);
  }
  //删除我的页面
  deleteMypage(index: number) {
    this.myPageList.splice(index, 1);
  }
  setParm() {
    if (this.route_type == this.androidType) {
      //安卓
      this.idx_img = 'idx_img';
      this.idx_word = 'idx_word';
      this.idx_charge = 'idx_charge';
      this.idx_mypage = 'idx_mypage';
      this.all_idx = 'idx_img,idx_img_index,idx_word,idx_charge,idx_mypage,idx_float,idx_evaluate';
      this.app_id = 'android_client';
      this.defaultuploadSizeType = '1080*740 png,jpg';
      this.maxW = 1080;
      this.maxH = 740;
    } else {
      //web
      this.idx_img = 'idx_img_web';
      this.idx_word = 'idx_word_web';
      this.all_idx = 'idx_img_web,idx_word_web';
      this.app_id = 'web_client';
      this.defaultuploadSizeType = '1920*700 png,jpg';
      this.maxW = 1920;
      this.maxH = 700;
    }
    this.imagesList = [];
    this.textImage = [];
    this.paramsImages.app_id = this.app_id;
    this.setValue();
  }
  mounted() {
    this.route_type = this.$route.meta!.type;
    this.setParm();
  }

  @Watch('$route.meta.type')
  onChangeValue(newVal: number, oldVal: number) {
    if (newVal != oldVal) {
      this.route_type = newVal;
      this.setParm();
    }
  }
}
